export const MEBIBYTE = 1024 * 1024;
export const SOURCE_MAX_BYTES = 20 * MEBIBYTE;
export const SHARE_MAX_BYTES = 15 * MEBIBYTE;
export const STATIC_MAX_PIXELS = 25_000_000;
export const GIF_MAX_FRAMES = 300;
export const GIF_MAX_DURATION_MS = 10_000;
export const GIF_MAX_LONGEST_EDGE = 1024;
export const GIF_MAX_PIXELS = 1_000_000;
export const GIF_MIN_DELAY_MS = 20;

export const OUTPUT_EDGE_OPTIONS = ['original', '2048', '1280'] as const;
export type OutputEdge = (typeof OUTPUT_EDGE_OPTIONS)[number];

export const GIF_PROFILES = {
  low: { label: 'Low', maxEdge: 360, maxFps: 10, quality: 60 },
  medium: { label: 'Medium', maxEdge: 480, maxFps: 15, quality: 75 },
} as const;

export type GifProfileName = keyof typeof GIF_PROFILES;

export const DEFAULT_SETTINGS = {
  quality: 80,
  outputEdge: 'original' as OutputEdge,
  gifProfile: 'medium' as GifProfileName,
};
